import { render, staticRenderFns } from "./RecentEpisodePlayersWidget.vue?vue&type=template&id=2ff870a1&"
import script from "./RecentEpisodePlayersWidget.vue?vue&type=script&lang=js&"
export * from "./RecentEpisodePlayersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports